@if (label) {
<div class="label">{{ label }}</div>
}
<ng-content></ng-content>
